import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	whyAmISeeingThis: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.why-am-i-seeing-this',
		defaultMessage: 'Why am I seeing this?',
		description: 'The label for the link that navigates to the [why am i seeing this] modal',
	},
	moreActions: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.more-actions',
		defaultMessage: 'More actions',
		description:
			'Used as the alt text for an icon button that when used shows a popup menu of more options.',
	},
	dismissButtonText: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.recommendations.common.recommendation-action-menu.dismiss-button-text',
		defaultMessage: 'Not interested',
		description:
			'Text for the "Not interested" button in the "setup required" section of the projects dropdown',
	},
});
